import React from "react"
import {
    Button, Container, Grid, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
} from "@material-ui/core"
import { DeleteForever, Edit, Restore } from "@material-ui/icons"
import { Pagination } from "@material-ui/lab"
import { Link } from "react-router-dom"
import mainStyles from '../WorkerManagementComponent/WorkerManagementComponent.module.css'
import paginationStyles from '../AgentSkillsManagement/styles.module.css'
import styles from './styles.module.css'
import { Pages } from "../../models/Pages"
import { ExemptDestination, isRemoved } from "../../models/ExemptDestinations/ExemptDestination"

interface IProps {
    destinations: ExemptDestination[]
    pagination: Pages | null
    handleChangePage: (page: number) => void
    onEdit: (destination: ExemptDestination) => void
    onRemove: (destination: ExemptDestination) => void
    onRestore: (destination: ExemptDestination) => void
}

/**
 * The exemption list.
 *
 * The number links to its own page rather than opening a dialog, because the question that
 * brings anyone here — who exempted this DID, when, and what did the last person say — is a
 * history question, and history does not fit in a row.
 */
const DestinationsList = (props: IProps) => {
    return (
        <Container maxWidth={false}>
            <Grid item xs={12} className={mainStyles.WorkerSkillsBack}>
                <TableContainer component={Paper}>
                    <Table aria-label="exempt destinations">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Number</TableCell>
                                <TableCell align="left">Reason</TableCell>
                                <TableCell align="left">Status</TableCell>
                                <TableCell align="left">Added by</TableCell>
                                <TableCell align="right">Updated</TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className={mainStyles.FlexColScroll}>
                            {props.destinations.length === 0 ?
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        <span className={styles.Muted}>Nothing here.</span>
                                    </TableCell>
                                </TableRow>
                                : null}
                            {props.destinations.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell align="left">
                                        <Link
                                            to={"/exempt-destination/" + row.phone_e164}
                                            className={styles.Phone}
                                        >
                                            {row.phone_e164}
                                        </Link>
                                    </TableCell>
                                    <TableCell align="left">
                                        <span className={styles.Comment}>{row.comment}</span>
                                    </TableCell>
                                    <TableCell align="left">
                                        {isRemoved(row) ?
                                            <span className={`${styles.Badge} ${styles.BadgeRemoved}`}>Removed</span>
                                            :
                                            <span className={`${styles.Badge} ${styles.BadgeActive}`}>Exempt</span>
                                        }
                                    </TableCell>
                                    <TableCell align="left">
                                        <span className={styles.Muted}>
                                            {row.creator ? row.creator.email : 'system'}
                                        </span>
                                    </TableCell>
                                    <TableCell align="right">
                                        <span className={styles.Muted}>{row.updated_at}</span>
                                    </TableCell>
                                    <TableCell align="right">
                                        {isRemoved(row) ?
                                            <Button color="default" onClick={() => props.onRestore(row)}>
                                                <Restore />&nbsp;Restore
                                            </Button>
                                            :
                                            <>
                                                <Button color="default" onClick={() => props.onEdit(row)}>
                                                    <Edit />
                                                </Button>
                                                <Button color="secondary" onClick={() => props.onRemove(row)}>
                                                    <DeleteForever />
                                                </Button>
                                            </>
                                        }
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {props.pagination !== null && props.pagination.LastPage > 1 ?
                    <Grid item xs={12}>
                        <Pagination
                            className={paginationStyles.Pagination}
                            count={props.pagination.LastPage}
                            page={props.pagination.CurrentPage}
                            onChange={(event: React.ChangeEvent<unknown> | null, newPage: number) =>
                                props.handleChangePage(newPage)}
                            variant="outlined"
                            shape="rounded"
                        />
                    </Grid>
                    : null}
            </Grid>
        </Container>
    )
}

export default DestinationsList
